{% block prems_discount_category_list %}
    <sw-page class="prems-discount-category-list">
        {% block prems_discount_category_list_search_bar %}
        <template #search-bar></template>
        {% endblock %}

        {% block prems_discount_category_list_smart_bar_header %}
        <template #smart-bar-header>
            {% block prems_discount_category_list_smart_bar_header_title %}
            <h2>
                {% block prems_discount_category_list_smart_bar_header_title_text %}
                {{ $tc('prems-discount-category.list.title') }}
                {% endblock %}
            </h2>
            {% endblock %}
        </template>
        {% endblock %}

        {% block prems_discount_category_list_smart_bar_actions %}
        <template #smart-bar-actions>
            {% block prems_discount_category_list_smart_bar_actions_add %}
            <mt-button
                size="default"
                variant="primary"
                @click="onCreate"
            >
                {{ $tc('prems-discount-category.list.button.add') }}
            </mt-button>
            {% endblock %}
        </template>
        {% endblock %}

        {% block prems_discount_category_list_language_switch %}
        <template #language-switch>
            <sw-language-switch @on-change="onChangeLanguage"/>
        </template>
        {% endblock %}
        <template #content>
            {% block prems_discount_category_list_content %}
            <div class="prems-discount-category-list__content">
                <sw-card-view slot="content">
                    <mt-card
                        :title="$tc('prems-discount-category.list.title')"
                        :large="true"
                    >
                        {% block prems_discount_category_list_grid %}
                        <sw-empty-state
                            v-if="(!items || !items.length) && !isLoading"
                            :title="$tc('prems-discount-category.list.grid.placeholder.description')"
                            :subline="''"
                            :absolute="false"
                        >
                            <template #icon>
                                <img
                                    :src="assetFilter('/administration/static/img/empty-states/products-empty-state.svg')"
                                    alt
                                />
                            </template>
                        </sw-empty-state>
                        <sw-entity-listing
                            v-else
                            slot="grid"
                            class="prems-discount-category-list"
                            :items="items"
                            :columns="columns"
                            :repository="repository"
                            :allowEdit="true"
                            :showSettings="true"
                            :isLoading="isLoading"
                            :allow-edit="true"
                            :allow-delete="true"
                            :allow-inline-edit="true"
                            :full-page="false"
                            :show-selection="false"
                            :plain-appearance="true"
                            detailRoute="prems.discount.category.detail"
                            style="border-radius: 0 0 8px 8px;"
                        >
                            {% block prems_discount_category_list_grid_column_name %}
                            <template #column-name="{ item }">
                                <router-link
                                    :to="{ name: 'prems.discount.category.detail', params: { id: item.id } }"
                                >
                                    {{ item.translated.name }}
                                </router-link>
                            </template>
                            {% endblock %}
                                    {% block prems_discount_category_list_grid_column_active %}
                            <template #column-active="{ item }">
                                <sw-status
                                    v-if="getItemStatus(item) == 1"
                                    color="green"
                                >
                                    {{ $tc('prems-discount-category.list.grid.value.activeLabel') }}
                                </sw-status>
                                <sw-status
                                    v-else-if="getItemStatus(item) == 2"
                                    color="orange"
                                >
                                    {{ $tc('prems-discount-category.list.grid.value.expiredLabel') }}
                                </sw-status>
                                <sw-status
                                    v-else
                                    color="gray"
                                >
                                    {{ $tc('prems-discount-category.list.grid.value.inactiveLabel') }}
                                </sw-status>
                            </template>
                            {% endblock %}
                                    {% block prems_discount_category_list_grid_column_priority %}
                            <template #column-priority="{ item }">
                                {{ item.priority ? item.priority : '' }}
                            </template>
                            {% endblock %}
                                    {% block prems_discount_category_list_grid_column_validFrom %}
                            <template #column-validFrom="{ item }">
                                {{ dateFilter(item.validFrom, {hour: '2-digit', minute: '2-digit'}) }}
                            </template>
                            {% endblock %}
                                    {% block prems_discount_category_list_grid_column_validUntil %}
                            <template #column-validUntil="{ item }">
                                {{ dateFilter(item.validUntil, {hour: '2-digit', minute: '2-digit'}) }}
                            </template>
                            {% endblock %}
                                    {% block prems_discount_category_list_grid_column_discount %}
                            <template #column-discount="{ item }">
                                {{ item.discount ? (item.type == '0' ? item.discount + ' %' : item.discount + ' €') : '' }}
                            </template>
                            {% endblock %}
                                    {% block prems_discount_category_list_grid_columns_actions %}
                            <template #more-actions="{ item }">
                                <!-- eslint-disable-next-line sw-deprecation-rules/no-twigjs-blocks -->
                                {% block prems_discount_category_list_grid_columns_actions_duplicate %}
                                <sw-context-menu-item
                                    class="prems-discount-category-list-grid__duplicate-action"
                                    @click="onDuplicate(item)"
                                >
                                    {{ $tc('prems-discount-category.list.button.duplicate') }}
                                </sw-context-menu-item>
                                {% endblock %}
                            </template>
                            {% endblock %}
                        </sw-entity-listing>
                        {% endblock %}
                    </mt-card>
                </sw-card-view>
            </div>
            {% endblock %}
        </template>
    </sw-page>
{% endblock %}